import {ForkEffect, put, select, takeLatest} from 'redux-saga/effects';
import {CLOSE_MODAL, updateModal} from '../actions/modal.actions';
import {handleElementsClickedAction} from '../actions/chalkBoardElements.actions';
import {AppState} from '../reducer';

function* closeModalSaga(): Generator<void> | void {
    const state: AppState = yield select();
    const elementsToUnclick = state.modalReducer.clickToDisplay;

    yield put(handleElementsClickedAction(elementsToUnclick, false));
    yield put(updateModal(false, '', []));
}

export function* watchModalSaga(): Generator<ForkEffect<never>, void> {
    yield takeLatest(CLOSE_MODAL, closeModalSaga);
}
